import { reject } from 'lodash';

const filterFieldsets = (fieldsets, excludeFieldsetsMap, site) => {
  const fieldsetsToExclude = excludeFieldsetsMap[site] || [];
  const filteredFieldsets = reject(fieldsets, fieldset =>
    fieldsetsToExclude.includes(fieldset.type)
  );
  return filteredFieldsets;
};

export default filterFieldsets;
